import React, { useState } from 'react';

import { useDebouncedValue, useDisclosure } from '@mantine/hooks';
import { AthleteRetrieve } from 'types';

import UploadedFilesFilter from './components/UploadedFilesFilter';
import UploadedFilesTable from './components/UploadedFilesTable';
import UploadFileForm from './components/UploadFileForm';

const UploadedFiles = ({
  athlete,
  permission = true,
}: {
  athlete: AthleteRetrieve;
  permission: boolean;
}): JSX.Element => {
  const [isCreateFilesOpen, { toggle: handleCreateFiles }] = useDisclosure(false);
  const [searchTerm, setSearchTerm] = useState<string>('');
  const [debouncedSearchTerm] = useDebouncedValue<string>(searchTerm, 250);
  const [fileId, setFileId] = useState<string | null>(null);

  const handleEditFile = (id: string): void => {
    setFileId(id);
    handleCreateFiles();
  };

  return (
    <>
      <UploadedFilesFilter
        openCreateFiles={handleCreateFiles}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        permission={permission}
      />
      <UploadedFilesTable
        handleEditFile={handleEditFile}
        searchTerm={debouncedSearchTerm}
        permission={permission}
        athleteId={athlete.athleteId}
      />
      <UploadFileForm
        opened={isCreateFilesOpen}
        closeHandler={handleCreateFiles}
        athleteId={athlete.athleteId}
        fileId={fileId}
        setFileId={setFileId}
        permission={permission}
      />
    </>
  );
};

export default UploadedFiles;
